<template>
  <v-form @keyup.enter="login" ref="form" lazy-validation>
    <v-text-field 
      type="text" 
      name="username"
      label="Nutzername" 
      v-model="username" 
      prepend-inner-icon="mdi-account"
      :color="color"
      :rules="[() => !!username || 'notwendig']"
      required
      outlined
      autofocus
    />
    <v-text-field 
      :type="showPassword ? 'text' : 'password'"
      name="password"
      style="width: 100%"
      label="Passwort" 
      v-model="password"
      prepend-inner-icon="mdi-lock"
      :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append-inner="showPassword = !showPassword"
      :color="color"
      :rules="[() => !!password || 'notwendig']"
      required
      outlined
    />
    <v-btn 
      @click="login"
      width="100%"
      rounded
      class="white--text"
      color="#1976d2"
      style="text-transform: none"
      name="login"
    >
      Anmelden
    </v-btn>
  </v-form>  
</template>

<script>
import requestService from "@/store/backendRequests"

export default {
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      color: "#0000ff"
    };
  },
  methods: {
    async login() {
      if (await this.$refs.form.validate()) {
        await requestService
          .login(this.username, this.password)
          .then(
            (response) => {      
              window.sessionStorage.setItem('accessToken', response.data.tokenType+" "+response.data.accessToken);
              window.sessionStorage.setItem('refreshToken', response.data.refreshToken);
              this.$store.dispatch('loggedIn');
            },
            (error) => {
              let message = error.response ? "Die Anmeldedaten wurden nicht erkannnt." : "Der Anmeldeserver ist nicht erreichbar.";
              this.$store.dispatch('displaySnackbarMessage', message);
              this.password = "";
            }
          );
      }
    },
  },
}
</script>
